import { Component } from '@angular/core';
import { MedicoService } from 'src/app/services/medico.service';
import { Medico } from 'src/app/models/medico.interface';
import { Producto } from 'src/app/models/producto.interface';
import { AuthService } from 'src/app/services/auth.service';
@Component({
  selector: 'app-medico-productos',
  templateUrl: './medico-productos.component.html',
  styleUrls: ['./medico-productos.component.scss']
})
export class MedicoProductosComponent {
  medico!: Medico;
  productos: Producto [] = [];
  constructor(private medicoService: MedicoService, private authService: AuthService){
    
    if(this.authService.isLoggedIn) {
        const id: number | undefined = this.authService.getUsuario?.medico?.id;
        if(id) this.obtenerInformacion(id);
    }

  }
  obtenerInformacion(id: number): void {
    this.medicoService.getMedicos(id).subscribe({
      next: (resp) => { 
       this.productos = resp.datos.productos; 
       this.medico = resp.datos; 
     //  console.log(resp)
      },
      error: (err) => console.log(err) 
   });
  }
}
